import { isTestcafeEnabled, isTestcafeAuthEnabled } from './testCafe';

const apiPrefix = isTestcafeEnabled()
    ? process.env.VUE_APP_API_BASE_TESTCAFE_URL
    : process.env.VUE_APP_API_BASE_URL;

const authPrefix = isTestcafeAuthEnabled()
    ? process.env.VUE_APP_API_BASE_AUTH_TESTCAFE_URL
    : process.env.VUE_APP_API_BASE_AUTH_URL;

export default {
    apiPrefix: apiPrefix + 'v1/',
    endpoints: {
        authenticate: authPrefix + 'authenticate',
        authentication_redirect: 'auth/redirect?token=:token',
        refresh: 'auth/refresh',
        logout: 'auth/logout',
        edition: 'edition',
        families: 'family-editions',
        families_not_attributed: 'family-editions/not-attributed',
        family: 'family-editions/:familyId/:privileged',
        family_duplicate: 'family-editions/same',
        familiesToAccept: 'families-to-accept/:familyId',
        families_to_accept_filter: 'families-to-accept/filter',
        families_to_accept_internal: 'families-to-accept/internal',
        families_to_accept_internal_with_convert: 'families-to-accept/internal/1',
        verified_consent: 'families-to-accept/:familyToAcceptId/verify-initial-consent',
        convertFamilyToAccept: 'families-to-accept/:family_id/convert',
        provinces: 'public/resource/provinces',
        provinces_for_family_to_accept: 'resource/provinces-for-family-to-accept',
        reporter_categories: 'public/resource/reporter-categories',
        help_categories: 'public/resource/support-criteria',
        source_categories: 'public/resource/source-categories',
        location: 'location/node-permissions/:buildingNumber/:city/:provinceId/:street',
        assign_location: 'families-to-accept/:FamilyToAcceptId/assign-wio-struct/:wioStructLocationId',
        location_leader: 'location/node-leaders/:buildingNumber/:city/:provinceId/:street',
        volunteers: 'volunteers/family-edition/:familyEditionId',
        my_families: 'family-editions/qualified',
        volunteer_accept_family: 'volunteers/family-edition/:familyEditionId/accept',
        volunteer_reject_family: 'volunteers/family-edition/:familyEditionId/reject',
        upload: process.env.VUE_APP_UPLOAD_BASE_URL + 'v1/upload',
        volunteer_refusal_reason: 'public/resource/volunteer-refusal-reason',
        similar_families: 'similar-family-editions',
        overwrite_similar_family: 'similar-family-editions/:familyId',
        families_to_decide: 'families-to-accept/to-decide',
        family_exclude: 'family-editions/:familyEditionId/exclude',
        family_include: 'family-editions/:familyEditionId/include',
        turn_off_reasons: 'public/resource/exclusion-reasons',
        turn_off_reasons_for_sheet: 'public/resource/exclusion-reasons/2',
        search: 'search-suggest/not-attributed',
        filters_resources: 'resource/family-edition-list-filter-data/:pageId',
        search_suggest_qualified: 'search-suggest/qualified',
        sheet_drafts: 'sheet-draft/:familyEditionId/:sheetType',
        sheet: 'sheet/:familyEditionId/:sheetType',
        rejon_per_province: 'resource/wio-structs-per-province/:provinceId',
        volunteers_per_region: 'resource/volunteers-search/:locationId',
        available_wio_structs: 'resource/available-wio-structs',
        change_wio_structs: 'family-editions/:familyEditionId/change-wio-struct/:wioId',
        sheet_resource: 'resource/sheet/:sheetId/:editionName',
        custom_content: process.env.VUE_APP_CUSTOM_CONTENT_URL,
        json_consent: 'public/consents/:file',
        patrial_sheet_data: 'sheet/:familyEditionId/:sheetType/partial-data',
        wio_struct_information: 'resource/wio-struct-information/:wioStructId',
        accept_warehouse: 'warehouse/accept/:warehouseId',
        warehouse: 'warehouse',
        single_warehouse: 'warehouse/:warehouseId',
        warehouse_draft: 'warehouse-draft/:warehouseWioStructId',
        warehouse_exist: 'warehouse/exist/:wioStructId',
        warehouses_per_location: 'warehouse/wio-struct/:wioStructId',
        warehouse_manager_list: 'warehouse/managers/:wioStructId/:warehouseType',
        turn_off_reasons_no_volunteer: 'public/resource/exclusion-reasons/3',
        family_edition_consent_uri:
      'resource/initial-consent/family-edition/:familyEditionId/:consentFileId',
        family_to_accept_consent_uri:
      'resource/initial-consent/family-to-accept/:familyToAcceptId/:consentFileId',
        families_per_warehouse: 'warehouse/:warehouseId/family-editions',
        sheet_permissions: 'resource/sheet-permissions/:familyEditionId/:type',
        preview_for_donor: 'family-editions/:familyId/details',
        family_volunteers: 'family-editions/:familyEditionId/volunteers',
        greater_needs: 'sheet/:familyId/greater-needs/:greaterNeedsflag',
        sheet_publish: 'sheet/:familyId/publish',
        resend_gift_giver_notification: 'gift-giver/:familyEditionId/resend-notification',
        resend_gift_giving_report_notification:
      'gift-giver/:familyEditionId/resend-gift-giving-report-notification',
        giftgiver_categories: 'public/resource/gift-giver-categories',
        gifetgiver_remove: 'gift-giver/:familyEditionId/remove',
        giftgiver_assign: 'gift-giver/:familyEditionId/assign',
        giftgiver_edit: 'gift-giver/:familyEditionId/edit',
        revoke_publication: 'family-editions/:familyEditionId/revoke-publication',
        gift_giving_report_data: 'gift-giver/:familyEditionId/show-gift-giving-report',
        gift_giving_report_draft: 'gift-giving-report-draft/:familyEditionId',
        pre_create_gift_giving_report: 'gift-giver/:familyEditionId/pre-create-gift-giving-report',
        volunteer_audit_comment: 'sheet/:familyEditionId/:sheetType/audit-comment-volunteer',
        area_audit_comment: 'sheet/:familyEditionId/:sheetType/audit-comment-correcting-area',
        national_audit_comment: 'sheet/:familyEditionId/:sheetType/audit-comment-correcting-national',
        send_to_area_audit: 'sheet/:familyEditionId/correction-area-send',
        send_to_area_correction: 'sheet/:familyEditionId/correction-area-send-back',
        send_to_national_audit: 'sheet/:familyEditionId/correction-national-send',
        sheet_corrections_area: 'sheet/:familyEditionId/:sheetType/correction-area-save',
        sheet_corrections_national: 'sheet/:familyEditionId/:sheetType/correction-national-save',
        send_to_national_correction: 'sheet/:familyEditionId/correction-national-send-back',
        send_to_national_correction_volunteer:
      'sheet/:familyEditionId/correction-national-send-volunteer',
        sheet_corrections_volunteer: 'sheet/:familyEditionId/:sheetType/correction-volunteer-save',
        gift_giving_report_audit_comment: 'gift-giver/:familyEditionId/audit-comment',
        volunteer_gift_giving_report_audit_comment:
      'gift-giver/:familyEditionId/audit-comment-volunteer',
        area_gift_giving_report_audit_comment:
      'gift-giver/:familyEditionId/audit-comment-correcting-area',
        national_gift_giving_report_audit_comment:
      'gift-giver/:familyEditionId/audit-comment-correcting-national',
        send_gift_giving_report_to_area_audit: 'gift-giver/:familyEditionId/correction-area-send',
        send_gift_giving_report_to_area_correction:
      'gift-giver/:familyEditionId/correction-area-send-back',
        send_gift_giving_report_to_national_audit:
      'gift-giver/:familyEditionId/correction-national-send',
        send_gift_giving_report_to_national_correction:
      'gift-giver/:familyEditionId/correction-national-send-back',
        send_gift_giving_report_to_national_correction_volunteer:
      'gift-giver/:familyEditionId/correction-national-send-volunteer',
        send_gift_giving_report: 'gift-giver/:familyEditionId/send-gift-giving-report',
        connect_family: 'similar-family-editions/:familyId/connect-family/:familyToConnectId',
        connect_family_duplicate: 'family-editions/:familyId/connect-family',
        similar_previous_edition: 'similar-family-editions/:familyId/previous-editions',
        family_mark_as_checked: 'family-editions/:familyId/mark-as-checked',
        initial_consent_file: 'family-editions/:familyEditionId/initial-consent-file/:uri',
        initial_consent_file_privileged:
      'family-editions/:familyEditionId/initial-consent-file-privileged/:uri',
        post_meeting_consent: 'resource/post-meeting-consent/family-edition/:familyEditionId',
        fcp_verify_warehouse: 'family-choice-path-import/bubble-warehouses/verify',
        fcp_execute_warehouse: 'family-choice-path-import/bubble-warehouses/execute',
        fcp_verify_families: 'family-choice-path-import/warehouse-families/verify',
        fcp_execute_families: 'family-choice-path-import/warehouse-families/execute',
        fcp_verify_bubbles: 'family-choice-path-import/bubbles/verify',
        fcp_execute_bubbles: 'family-choice-path-import/bubbles/execute',
        fcp_counters: 'family-choice-path-import/counters',
        fcp_current_bubbles: 'family-choice-path-import/bubbles',
        fcp_current_bubble_warehouses: 'family-choice-path-import/bubble-warehouses',
        fcp_current_warehouse_families: 'family-choice-path-import/warehouse-families',
        edit_family_description: 'family-editions/:familyEditionId/description',
        specialist_package: 'specialist-package/:familyEditionId/:type',
        specialist_package_draft: 'specialist-package-draft/:familyEditionId/:type',
        further_story: 'family-edition-meeting-note/:familyEditionId/:noteId',
        further_story_summary: 'family-edition-meetings-summary/:familyEditionId'
    },
    get (endpointLabel, params) {
        if (this.endpoints[endpointLabel] === undefined) {
            throw new Error('undefined api path');
        }

        let url = this.endpoints[endpointLabel];

        if (typeof params === 'object') {
            for (const param in params) {
                url = url.replace(':' + param, params[param]);
            }
        }

        if (url.indexOf('/:') > 0) {
            url = url.substring(0, url.indexOf('/:'));
        }

        if (this.endpoints[endpointLabel].includes('http')) {
            return url;
        }

        return this.apiPrefix.concat(url);
    },
    getWithURLParams (endpointLabel, params) {
        if (this.endpoints[endpointLabel] === undefined) {
            throw new Error('undefined api path');
        }

        let url = this.endpoints[endpointLabel];

        if (typeof params === 'object' && Object.prototype.hasOwnProperty.call(params, 'urlParams')) {
            for (const param in params) {
                if (param !== 'urlParams') {
                    url = url.replace(':' + param, params[param]);
                } else {
                    url = url + '?' + params[param];
                }
            }
        } else {
            url = url + '?' + params;
        }

        if (this.endpoints[endpointLabel].includes('http')) {
            return url;
        }

        return this.apiPrefix.concat(url);
    }
};
